const CacheKeys = [
    {
        key: 'api/Company'
    },
    {
        key: 'api/Branch'
    },
    {
        key: 'api/Division'
    },
    {
        key: 'api/SalesOrderType'
    }
];

export default CacheKeys;